import { Injectable } from "@angular/core";
import { ApiService } from "../http/api.service";
import { AppVersionsConfigResponse, UpdateAppVersionsRequest } from "../../shared/backend-api.types";
import { apiPath } from "../../shared/api-path.const";

@Injectable({
  providedIn: "root",
})
export class AppVersionsApiService {
  constructor(private readonly apiService: ApiService) {}

  public getAppVersions(): Promise<AppVersionsConfigResponse> {
    return this.apiService.sendGetRequest<AppVersionsConfigResponse>(`${apiPath.config}/app-versions`, undefined);
  }

  public setAppVersions(request: UpdateAppVersionsRequest): Promise<AppVersionsConfigResponse> {
    return this.apiService.sendPutRequest<UpdateAppVersionsRequest, AppVersionsConfigResponse>(
      `${apiPath.config}/app-versions`,
      request,
    );
  }
}
